
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"22","viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.908 5.074a.392.392 0 00-.193-.105l-1.29-.188-.573-1.16a.449.449 0 00-.229-.187.399.399 0 00-.316.029.454.454 0 00-.164.152l-.575 1.166-1.26.182-.023.006c-.135.03-.205.117-.228.14l-.024.03a.413.413 0 00-.064.299.445.445 0 00.111.222l.914.89-.217 1.278c-.006.065 0 .17.07.276l.024.029a.414.414 0 00.31.146.365.365 0 00.182-.047l1.125-.591 1.143.603a.39.39 0 00.293.012.425.425 0 00.246-.217.483.483 0 00.035-.234L8.988 6.55l.926-.903a.405.405 0 00.106-.275v-.03a.35.35 0 00-.112-.269zm-1.53 1.272l.212 1.213-1.09-.575-1.09.575.205-1.213-.879-.862 1.22-.175.544-1.102.545 1.102 1.219.175-.885.862z","fill":"#fff"}}),_c('path',{attrs:{"d":"M14.115 2.139H12.41V1.066a.523.523 0 00-.521-.521H3.11a.523.523 0 00-.521.521V2.14H.885a.72.72 0 00-.72.72v1.489a3.194 3.194 0 002.612 3.14 4.808 4.808 0 001.037 2.01 4.883 4.883 0 002.28 1.453l-.903 1.945h-.005a.526.526 0 00-.528.534v1.03h5.678v-1.03a.525.525 0 00-.527-.528L8.9 10.957a4.883 4.883 0 002.28-1.453 4.808 4.808 0 001.037-2.01 3.188 3.188 0 002.613-3.14V2.859a.712.712 0 00-.715-.72zM.745 4.348V2.859c0-.082.064-.146.146-.146h1.705v3.17c0 .328.023.656.07.984a2.612 2.612 0 01-1.922-2.52zm10.98 2.707c-.147.79-.48 1.5-.973 2.056a4.339 4.339 0 01-2.139 1.319l-.527.135 1.353 2.912h.323v.404H5.238v-.404h.323l1.353-2.912-.521-.135a4.339 4.339 0 01-2.14-1.319c-.491-.556-.825-1.271-.972-2.056a6.51 6.51 0 01-.111-1.172V1.119h8.66v4.764c0 .398-.035.79-.105 1.172zm2.53-2.707a2.62 2.62 0 01-1.915 2.52c.047-.323.07-.651.07-.985v-3.17h1.705c.082 0 .147.064.147.146v1.489h-.006z","fill":"#fff"}})])
          )
        }
      }
    